import React, { useState, useEffect } from 'react';
import { Container, Card, Row, Col, Form, Button } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios";
import DataTable from 'react-data-table-component';
import loading from "../../assets/images/common/loading.gif";
import Header from '../../components/layout/header/header';
import LeftNav from '../../components/layout/leftNav/leftNav';
import { Tooltip } from "@mui/material";
import AppDataGrid from "../../components/common/AppDataGrid";

const Assignlanguages = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [classes, setClasses] = useState([]);
    const [academic, setAcademic] = useState([]);
    const [sections, setSections] = useState([]);
    const [attendanceData, setAttendanceData] = useState([]);
    const [attendanceDate, setAttendanceDate] = useState("");
    const [students, setStudents] = useState([]);
    const [isLoading, setIsLoading] = useState(false); // ✅ added

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const userData = sessionStorage.getItem('user');
    const userObj = userData ? JSON.parse(userData) : {};

    const [filter, setFilter] = useState({
        class_id: 0,
        section_id: 0,
        academic_year_id: 0,
        school_id: userObj.school_id,
        action: "READ",
    });

    const fetchClasses = async () => {
        try {
            const response = await axios.post(baseUrl + "/classes/", {
                action: "READ",
                school_id: userObj.school_id
            });
            setClasses(response.data);
        } catch (error) {
            console.log("Error fetching class name :", error);
        }
    };

    useEffect(() => {
        fetchClasses();
        fetchAcademicYears();
    }, []);

    const fetchSections = async (class_id) => {
        try {
            const response = await axios.post(baseUrl + "/Sections/", {
                action: "DROPDOWNREAD",
                class_id: class_id
            });
            setSections(response.data);
        } catch (error) {
            console.log("Error fetching section name:", error);
        }
    };

    useEffect(() => {
        fetchSections(filter.class_id || 0);
    }, [filter.class_id]);

    const fetchAcademicYears = async () => {
        try {
            const response = await axios.post(baseUrl + "/AcademicYear/", {
                action: "READ",
                school_id: userObj.school_id
            });
            setAcademic(response.data);
        } catch (error) {
            console.log("Error fetching academic name:", error);
        }
    };

    const columns = [
        {
            field: 'student_name',
            headerName: "Student Name",
            flex: 1,
            renderCell: (params) => <Tooltip title={params.value}><span>{params.value}</span></Tooltip>,
            sortable: true,
        },
        {
            field: 'class_name',
            headerName: "Class",
            flex: 1,
            renderCell: (params) => <Tooltip title={params.value}><span>{params.value}</span></Tooltip>,
            sortable: true,
        },
        {
            field: 'section_name',
            headerName: "Section",
            flex: 1,
            renderCell: (params) => <Tooltip title={params.value}><span>{params.value}</span></Tooltip>,
            sortable: true,
        },
        {
            field: 'first_language',
            headerName: "First language",
            flex: 1,
            renderCell: (params) => <Tooltip title={params.value}><span>{params.value}</span></Tooltip>,
            sortable: true,
        },
        {
            field: 'second_language',
            headerName: " Second Language",
            flex: 1,
            renderCell: (params) => <Tooltip title={params.value}><span>{params.value}</span></Tooltip>,
            sortable: true,
        },
        {
            field: 'third_language',
            headerName: "Third Language",
            flex: 1,
            renderCell: (params) => <Tooltip title={params.value}><span>{params.value}</span></Tooltip>,
            sortable: true,
        },
    ];

    const handleFilterSubmit = async (e) => {
        e.preventDefault();

        // Clear previous data
        setStudents([]);

        // Validate each field individually
        if (!filter.academic_year_id || filter.academic_year_id === "0") {
            toast.error("Please select Academic Year");
            return;
        }

        if (!filter.class_id || filter.class_id === "0") {
            toast.error("Please select Class");
            return;
        }

        if (!filter.section_id || filter.section_id === "0") {
            toast.error("Please select Section");
            return;
        }

        try {
            setIsLoading(true); // ✅ start loading
            const response = await axios.post(baseUrl + "/notpromoted/", filter);
            setStudents(response.data || []);
        } catch (error) {
            toast.error("Error fetching student data");
            console.error(error);
        } finally {
            setIsLoading(false); // ✅ stop loading
        }
    };

    const searchableColumns = [
        (row) => row.student_name,
        (row) => row.class_name,
        (row) => row.section_name,
        (row) => row.first_language,
        (row) => row.second_language,
        (row) => row.third_language,
    ];

    // ✅ use students (NOT academic) so grid can show "No rows"
    const filteredRecords = (students || []).filter((item) =>
        searchableColumns.some((selector) => {
            const value = selector(item);
            const stringValue = String(value || "").toLowerCase().replace(/[-\s]+/g, "");
            const normalizedQuery = searchQuery.toLowerCase().replace(/[-\s]+/g, "");
            return stringValue.includes(normalizedQuery);
        })
    );

    return (
        <div className='pageBody'>
            <ToastContainer />
            <div className="commonDataTableHead">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <h6 className="commonTableTitle">Assigning Languages</h6>
                    </div>
                </div>
            </div>

            <Container fluid>
                <Card>
                    <Card.Body>
                        <form onSubmit={handleFilterSubmit}>
                            <Row>
                                <Col xs={12} md={6} lg={3} xxl={4}>
                                    <div className='commonInput'>
                                        <Form.Group>
                                            <Form.Label>Academic Year<span className='requiredStar'></span></Form.Label>
                                            <select
                                                className="form-select"
                                                id="academic_year_id"
                                                required
                                                value={filter.academic_year_id}
                                                onChange={(e) => setFilter({ ...filter, academic_year_id: e.target.value })}
                                            >
                                                <option value="0" disabled hidden>Select Academic Year</option>
                                                {(academic || []).map((academic) => (
                                                    <option key={academic.academic_year_id} value={academic.academic_year_id}>
                                                        {academic.academic_year_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </Form.Group>
                                    </div>
                                </Col>

                                <Col xs={12} md={6} lg={4} xxl={4}>
                                    <div className='commonInput'>
                                        <Form.Group>
                                            <Form.Label> Class </Form.Label>
                                            <select
                                                type="number"
                                                className="form-select"
                                                id="class_id"
                                                required
                                                value={filter.class_id}
                                                onChange={(e) => setFilter({ ...filter, class_id: e.target.value })}
                                            >
                                                <option value="0" disabled hidden>Select Class</option>
                                                {(classes || [])
                                                    .filter((classItem) => classItem.is_active === "Active")
                                                    .map((classItem) => (
                                                        <option key={classItem.class_id} value={classItem.class_id}>
                                                            {classItem.class_name}
                                                        </option>
                                                    ))}
                                            </select>
                                        </Form.Group>
                                    </div>
                                </Col>

                                <Col xs={12} md={6} lg={4} xxl={4}>
                                    <div className='commonInput'>
                                        <Form.Group>
                                            <Form.Label>Section</Form.Label>
                                            <select
                                                className="form-select"
                                                id="section_id"
                                                required
                                                value={filter.section_id}
                                                onChange={(e) => setFilter({ ...filter, section_id: e.target.value })}
                                            >
                                                <option value="0" disabled hidden>Select Section</option>
                                                {(sections || []).map((section, index) => (
                                                    <option key={index} value={section.section_id}>
                                                        {section.section_name}
                                                    </option>
                                                ))}
                                            </select>
                                            <Form.Control.Feedback>Required</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <div className="d-flex justify-content-between mt-4">
                                        <Button
                                            type="button"
                                            variant="primary"
                                            className="btn-info clearBtn"
                                            onClick={() => {
                                                setAttendanceDate("");
                                                setAttendanceData([]);
                                                setStudents([]); // ✅ clear grid as well
                                            }}
                                        >
                                            Reset
                                        </Button>

                                        <Button
                                            type="submit"
                                            variant="primary"
                                            className="btn-success primaryBtn"
                                        >
                                            Submit
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </Card.Body>
                </Card>

                <div className="commonTable height100 mt-2">
                    <div className="tableBody">
                        {isLoading ? ( // ✅ same pattern as Syllabus
                            <div className="loadingContainer">
                                <img src={loading} alt="Loading..." className="loadingGif" />
                            </div>
                        ) : (
                            <AppDataGrid
                                rows={filteredRecords}
                                columns={columns}
                                getRowId={(r) => r.student_id || `${r.student_name}-${r.class_id}-${r.section_id}`}
                                showToolbar={false}
                                pagination
                                pageSizeOptions={[10, 20, 50]}
                                density="compact"
                                maxHeight={450}
                            />
                        )}
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default Assignlanguages;
